import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CoreService } from '../../../../core/services/core.service';

@Component({
  selector: 'app-create-saved-view-dialog',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './create-saved-view-dialog.component.html',
  styleUrl: './create-saved-view-dialog.component.css'
})

export class CreateSavedViewDialogComponent {

  name: string = 'New View';
  setAsDefault: boolean = false;
  nameTouched: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private coreService: CoreService
  ) {

  }

  get isNameInvalid(): boolean {
    return !this.name || !this.name.trim();
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  onCreate() {
    if (this.isNameInvalid) {
      this.nameTouched = true;
      return;
    }
    const guid = this.generateGuid();

    // Get current camera position and orientation dynamically
    const camera = this.coreService.getViewer().camera;
    const ellipsoid = this.coreService.getViewer().scene.globe.ellipsoid;
    const cartographicPos = ellipsoid.cartesianToCartographic(camera.position);


    const savedView = {
      name: this.name,
      id: 'saved-view-' + guid,
      date: new Date().toISOString(),
      position: {
        longitude: cartographicPos.longitude,
        latitude: cartographicPos.latitude,
        height: cartographicPos.height
      },
      heading: camera.heading,
      pitch: camera.pitch,
      roll: camera.roll,
      isDefault: this.setAsDefault
    };

    this.activeModal.close(savedView);
  }

  private generateGuid(): string {
    // Simple GUID generator
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

}